import React from "react";
import PropTypes from "prop-types";
import Image from "../../elements/Image";

const propTypes = {
	image: PropTypes.string.isRequired,
	client: PropTypes.object.isRequired,
	challenge: PropTypes.object.isRequired,
	solution: PropTypes.object.isRequired,
	quote: PropTypes.object.isRequired,
	url: PropTypes.object.isRequired,
};

const defaultProps = {
	image: "",
	client: undefined,
	challenge: undefined,
	solution: undefined,
	quote: undefined,
	url: undefined,
};

const SuccessStory = ({ ...props }) => {
	return (
		<div className="section-success-stories__wrapper">
			<div className="section-success-stories__wrapper--header">
				<Image src={props.image} alt="Image" className="img-fluid" />
			</div>
			<div className="section-success-stories__wrapper__content">
				<div className="row">
					<div className="col-lg-6 mx-auto">
						<div className="section-success-stories__wrapper__content__box">
							<h5>{props.client.title}</h5>
							<h4>{props.client.name}</h4>
							<p>{props.client.text}</p>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-6">
						<div className="section-success-stories__wrapper__content__box">
							<h5>{props.challenge.title}</h5>
							<h4>{props.challenge.name}</h4>
							<p>{props.challenge.text}</p>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="section-success-stories__wrapper__content__box">
							<h5>{props.solution.title}</h5>
							<h4>{props.solution.name}</h4>
							<p>{props.solution.text}</p>
						</div>
					</div>
				</div>
				<div className="section-success-stories__wrapper__content__quote">
					<p>{props.quote.text}</p>
					<h5>{props.quote.author}</h5>
				</div>
			</div>
			<div className="section-success-stories__wrapper--url">
				<h4>
					Check out our work at <a href={props.url.link}>{props.url.title}</a>
				</h4>
			</div>
		</div>
	);
};

SuccessStory.propTypes = propTypes;
SuccessStory.defaultProps = defaultProps;

export default SuccessStory;
